
export const groupBy = (xs: readonly any[], key: string | number | null) => {
    if(!key) return []
    return xs.reduce(function(rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
    }, {});
};